import { gql, useMutation } from '@apollo/client';

export enum CompanyImageUploadPurposeEnum {
  BUBBLE_AVATAR = 'BUBBLE_AVATAR',
  WIDGET_LOGO = 'WIDGET_LOGO',
  CHAT_BACKGROUND = 'CHAT_BACKGROUND',
  COMPANY_AVATAR = 'COMPANY_AVATAR',
}

export type CompanyImageUploadArgs = {
  companyId: string;
  purpose: CompanyImageUploadPurposeEnum;
  upload: any;
};

export const mutation = gql`
  mutation ($companyId: String!, $purpose: CompanyImageUploadPurposeEnum!, $upload: Upload!) {
    companyImageUpload(companyId: $companyId, purpose: $purpose, upload: $upload)
  }
`;

const useCompanyImageUpload = () => {
  const [mutate, { loading, error }] = useMutation<{ companyImageUpload: string }, CompanyImageUploadArgs>(mutation);
  return { uploadImage: mutate, uploading: loading, error };
};

export default useCompanyImageUpload;
